import {Box, Drawer, List} from '@mui/material'
import {useAuth} from 'app/modules/auth/auth'
import {useUser} from 'app/modules/auth/hooks'
import {getLocalStorage} from 'app/utils'
import {useNavigate} from 'react-router-dom'
import {MenuItem} from '_metronic/layout/components/header/MenuItem'

export function MainDrawer() {
  const {closeDrawerMenu, logout, isLoggedIn} = useAuth()
  const {data} = useUser(getLocalStorage('access_token'))
  let loggedIn =
    isLoggedIn && data?.data.data !== 'خطای احراز هویت' && getLocalStorage('access_token')
  const handleClose = () => {
    closeDrawerMenu()
  }
  const navigate = useNavigate()
  const handleLogin = () => {
    const API_URL = process.env.REACT_APP_API_URL
    if (loggedIn) navigate('/profile')
    else window.open(API_URL + '/login', '_self')
  }
  const list = () => {
    return (
      <Box sx={{width: 200}} role='presentation' onClick={handleClose} onKeyDown={handleClose}>
        <List>
          <MenuItem title='پنجره واحد خدمات دانشگاه' to='/dashboard' />
          <div className='menu-item me-lg-1'>
            <div className='menu-link py-3' onClick={() => handleLogin()}>
              {loggedIn ? (
                <span className='menu-title'>پروفایل</span>
              ) : (
                <span className='menu-title'>ورود از طریق پنجره ملی خدمات دولت هوشمند</span>
              )}
            </div>
          </div>
          {loggedIn && (
            <div className='menu-item me-lg-1'>
              <div
                className='menu-link py-3'
                onClick={() => {
                  navigate('/dashboard')
                  logout()
                }}
              >
                <span className='menu-title'>خروج</span>
              </div>
            </div>
          )}
          <div className='menu-item me-lg-1'>
            <div
              className='menu-link py-3'
              onClick={() => window.open('https://birjand.ac.ir', '_self')}
            >
              <span className='menu-title text-primary fs-5'>صفحه اصلی دانشگاه </span>
            </div>
          </div>
        </List>
      </Box>
    )
  }

  return (
    <Drawer anchor='right' open={true} onClose={handleClose}>
      {list()}
    </Drawer>
  )
}
